import type { CombatFeedbackMessage } from "@mucki/shared";

export interface CombatText {
  spawn(message: CombatFeedbackMessage, screen: { x: number; y: number }): void;
  dispose(): void;
}

const LIFETIME_MS = 900;

/**
 * Short-lived floating numbers. Values come from the server's combat feedback
 * message, never from inferring a state delta.
 */
export function createCombatText(parent: HTMLElement = document.body): CombatText {
  const live = new Set<HTMLElement>();

  return {
    spawn: (message, screen) => {
      const element = document.createElement("div");
      const tone = message.killed ? "kill" : message.kind;
      element.className = `combat-text combat-text--${tone}`;
      element.textContent =
        message.kind === "heal" ? `+${Math.round(message.amount)}` : `-${Math.round(message.amount)}`;
      element.style.left = `${screen.x}px`;
      element.style.top = `${screen.y}px`;
      parent.appendChild(element);
      live.add(element);

      requestAnimationFrame(() => {
        element.style.transform = "translate(-50%, -180%)";
        element.style.opacity = "0";
      });

      window.setTimeout(() => {
        element.remove();
        live.delete(element);
      }, LIFETIME_MS);
    },
    dispose: () => {
      for (const element of live) element.remove();
      live.clear();
    },
  };
}
